import {
  objectSchema,
  optionalTolerant,
} from '../../_utils/fcdc-v2'
import * as z from 'zod'

/** Wrapper around one settings value. `actual` may be null when a form clears it. */
export function settingOf<T extends z.ZodType>(actual: T) {
  return objectSchema({
    actual: optionalTolerant(z.union([z.null(), actual])),
    notOverridable: optionalTolerant(z.boolean()),
    countryOverrideIllegal: optionalTolerant(z.boolean()),
  })
}

export const SettingSchema = settingOf(z.unknown())
